<template lang="html">
  <el-dialog
    title="查看轨迹"
    v-if="dialogVisible"
    :visible="dialogVisible"
    @close="close"
    width="70%"
    append-to-body
    class="receipt-dialog"
  >
    <iframe
      data-v-36dc0f44=""
      name="myiframe"
      id="myrame"
      :src="iframeSrc"
      class="piccIframe"
      ><p data-v-36dc0f44="">你的浏览器不支持iframe标签</p></iframe
    >
    <span slot="footer" class="dialog-footer"> </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    orderNo: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    iframeSrc() {
      return `http://xyh5ssl.xiangyun360.com/truck-history-map?orderNo=${this.orderNo}`;
    }
  },
  created() {},
  mounted() {},
  methods: {
    close() {
      this.$emit("update:dialogVisible", false);
    },
    initData() {}
  },
  watch: {
    dialogVisible(newVal) {
      newVal && this.initData();
    }
  },
  components: {}
};
</script>

<style lang="scss">
#myrame {
  width: 100%;
  height: calc(100vh - 320px);
  .detail-wrap {
    font-size: 12px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/order/detail/components/viewPathDialog/index.vue